import React from "react";
import { SelectionIndicatorDiv } from "./styled-components";

export const TabSelectionIndicator = () => (
  <SelectionIndicatorDiv className="glider" />
);
